import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center overflow-hidden" style={{
    background: 'radial-gradient(ellipse at top, #FFFFFF 0%, #F4FBF6 60%, #E8F5EC 100%)'
  }} data-id="element-175">
      <div className="absolute top-10 left-1/4 w-[380px] h-[380px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(92, 203, 127, 0.25)'
    }} data-id="element-176"></div>
      <div className="absolute bottom-10 right-1/4 w-[340px] h-[340px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(30, 142, 90, 0.15)'
    }} data-id="element-177"></div>

      <div className="relative bg-white border border-border-light text-primary font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2 shadow-sm" data-id="element-178">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-secondary animate-pulse" data-id="element-179"></span>
        <span className="hidden sm:inline" data-id="element-180">
          🧬 ATTENZIONE: DOCENTI DI BIOLOGIA STANCHI DI PASSARE ORE A PREPARARE
          LEZIONI
        </span>
        <span className="sm:hidden" data-id="element-181">ATTENZIONE: DOCENTI DI BIOLOGIA</span>
      </div>

      <h1 className="relative font-montserrat font-black max-w-5xl text-[26px] leading-[1.15] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-4 sm:mb-6 tracking-tight text-text-main" data-id="element-182">
        Organizza tutto il tuo anno di biologia in{' '}
        <span className="text-transparent bg-clip-text" style={{
        backgroundImage: 'linear-gradient(90deg, #1E8E5A 0%, #5CCB7F 100%)'
      }} data-id="element-183">
          pochi minuti.
        </span>
      </h1>

      <p className="relative text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-white/60 sm:backdrop-blur-sm sm:border sm:border-border-light sm:border-l-4 sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left sm:shadow-sm text-text-sec" style={{
      borderLeftColor: '#1E8E5A'
    }} data-id="element-184">
        Il sistema{' '}
        <span className="font-bold text-primary" data-id="element-185">"Apri e Insegna"</span>{' '}
        progettato per la scuola media e superiore italiana.{' '}
        <span className="hidden sm:inline font-semibold text-text-main" data-id="element-186">
          Lezioni pronte, laboratori, verifiche, attività e mappe concettuali
          già organizzate.
        </span>
      </p>

      <div className="relative w-full max-w-[280px] sm:max-w-[460px] md:max-w-[600px] mx-auto mb-4 sm:mb-8" data-id="element-187">
        <div className="absolute inset-0 blur-[50px] rounded-full hidden sm:block" style={{
        background: 'rgba(92, 203, 127, 0.2)'
      }} data-id="element-188"></div>
        <img src="https://cdn.magicpatterns.com/uploads/9u8PHjmMrN46JX2xz94Bz5/32f3f9b3-cb01-4c89-9cfd-9abf8227a195.png" alt="BIOLOGIA PRONTA: IL KIT COMPLETO — Sistema Integrale di Insegnamento" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(30,142,90,0.2)]" width={600} height={428} fetchPriority="high" loading="eager" decoding="async" data-id="element-189" />
      </div>

      <div className="relative flex flex-col items-center gap-2 mb-4 sm:mb-6" data-id="element-190">
        <div className="flex items-center gap-2" data-id="element-191">
          <span className="text-sm sm:text-lg text-[#E0A52E]" data-id="element-192">⭐⭐⭐⭐⭐</span>
          <span className="text-xs sm:text-base font-medium text-text-sec" data-id="element-193">
            4.9/5 (+1.200 Recensioni Verificate)
          </span>
        </div>
      </div>

      <a href="#pricing" onClick={() => {
      const w = window as any;
      if (w.fbq) {
        w.fbq('track', 'AddToCart', {
          content_name: 'Biologia Pronta — Il Kit Completo',
          content_type: 'product',
          value: 19.9,
          currency: 'EUR'
        });
      }
    }} className="relative btn-primary-pulse font-montserrat font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white bg-cta-green hover:bg-cta-green-hover" data-id="element-194">
        🚀 SÌ! VOGLIO RISPARMIARE ORE DI PREPARAZIONE
      </a>

      <p className="relative text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap text-text-sec" data-id="element-195">
        <span data-id="element-196">⚡ Accesso Immediato</span>
        <span data-id="element-197">•</span>
        <span data-id="element-198">🛡️ Garanzia 7 Giorni</span>
        <span data-id="element-199">•</span>
        <span data-id="element-200">💳 Pagamento Unico</span>
      </p>
    </section>;
}